import React, {useEffect, useCallback} from 'react';

import styles from "./HomeTips.module.css";
import {FontIcon} from "@/app/_components";

interface HomeTipsProps {
    // key:number;
}

const HomeTips: React.FC<HomeTipsProps> = (props) => {
    // 点击外部区域关闭提示框
    useEffect(() => {

    }, []);

    return (
        <div className={styles.home_tips}>
            <ul className={`${styles.home_tips_main} center-space-between`}>
                <li className={`${styles.home_item} center`}>
                    <FontIcon
                        icon="s-h_tip1"
                        className={styles.home_icon}
                    />
                    <span className={styles.home_txt}>FAST PAYOUTS</span>
                </li>
                <li className={`${styles.home_item} center`}>
                    <FontIcon
                        icon="s-h_tip2"
                        className={styles.home_icon}
                    />
                    <span className={styles.home_txt}>GREAT PEARKS</span>
                </li>
                <li className={`${styles.home_item} center`}>
                    <FontIcon
                        icon="s-h_tip3"
                        className={styles.home_icon}
                    />
                    <span className={styles.home_txt}>24HOURS SUPPORT</span>
                </li>

            </ul>
        </div>
    )
};

export default HomeTips;
